import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../../../../../../components/global/Button';
import PinField from '../../../../../../components/global/PinField';
import Alert from '../../../../../../components/global/Alert';

const propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  values: PropTypes.shape({
    phone_number: PropTypes.string.isRequired,
  }).isRequired,
  onPinCodeResend: PropTypes.func.isRequired,
  onEmailSignup: PropTypes.func.isRequired,
};

const INACTIVITY_TIMEOUT = 20000; // 20s

const RegistrationPhoneVerify = ({
  className,
  loading,
  handleSubmit,
  handleChange,
  onPinCodeResend,
  onEmailSignup,
  values,
}) => {
  const [showEmailSignupPrompt, setShowEmailSignupPrompt] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowEmailSignupPrompt(true);
    }, INACTIVITY_TIMEOUT);
  }, []);
  const classes = classNames({
    [className]: !!className,
  });
  const isValid = values.code?.length === 4;

  return (
    <div className={classes}>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <PinField
            className="registration-pin-field"
            onComplete={value => {
              handleChange({
                target: {
                  name: 'code',
                  value,
                },
              });
            }}
            onChange={value => {
              handleChange({
                target: {
                  name: 'code',
                  value,
                },
              });
            }}
          />
        </div>

        <div>
          <Button
            type="submit"
            disabled={loading || !isValid}
            loading={loading}
            className="d-block mt-2"
          >
            {loading ? 'Processing...' : 'Verify Pin Code'}
          </Button>

          <Button
            type="button"
            btnStyle="link"
            disabled={loading}
            loading={loading}
            className="d-block mt-2"
            onClick={() => onPinCodeResend(values)}
          >
            Re&ndash;send code
          </Button>
        </div>
        {showEmailSignupPrompt && (
          <Alert type="info" className="d-flex align-items-baseline mt-2">
            Not receiving the SMS?{' '}
            <Button btnStyle="link" className="ml-1" onClick={onEmailSignup}>
              Authenticate with email
            </Button>
          </Alert>
        )}
      </form>
    </div>
  );
};

RegistrationPhoneVerify.propTypes = propTypes;

export default RegistrationPhoneVerify;
